import { CxEvent } from '@spartacus/core';

export class Ga4GgProductWhereToBuyEvent extends CxEvent {
  event?: string;
  currency?: string;
  value?: number;
  visitor_type?: string;
  items?: {
    item_id?: string;
    item_name?: string;
    price?: number;
  }[];
}
